import * as React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  BooleanInput,
  ReferenceArrayInput,
  SelectArrayInput,
  FormDataConsumer,
} from "react-admin";
import { useClub } from "../club/ClubContext";

export function CalendarFeedCreate(props: any) {
  const { clubId } = useClub();

  return (
    <Create
      {...props}
      transform={(data: any) => ({
        ...data,
        club_id: clubId,
        team_ids: data.scope === "TEAMS" ? (data.team_ids ?? []) : [],
      })}
    >
      <SimpleForm>
        <TextInput source="name" label="Name" validate={required()} fullWidth />
        <TextInput source="url_https" label="ICS URL (https)" validate={required()} fullWidth />
        <SelectInput
          source="scope"
          label="Sichtbarkeit"
          defaultValue="ALL_CLUB"
          choices={[
            { id: "ALL_CLUB", name: "Alle im Verein" },
            { id: "TEAMS", name: "Nur bestimmte Teams" },
          ]}
          fullWidth
        />
        <SelectInput
          source="sync_mode"
          label="Modus"
          defaultValue="SUBSCRIBE_AND_IMPORT"
          choices={[
            { id: "SUBSCRIBE_ONLY", name: "Nur abonnieren" },
            { id: "IMPORT_ONLY", name: "Nur importieren" },
            { id: "SUBSCRIBE_AND_IMPORT", name: "Abonnieren + Import" },
          ]}
          fullWidth
        />

        <FormDataConsumer>
          {({ formData }) =>
            formData?.scope === "TEAMS" ? (
              <ReferenceArrayInput
                source="team_ids"
                reference="teams"
                label="Teams"
                filter={clubId ? { clubId } : {}}
              >
                <SelectArrayInput optionText="name" />
              </ReferenceArrayInput>
            ) : null
          }
        </FormDataConsumer>

        <BooleanInput source="is_active" label="Aktiv" defaultValue />
      </SimpleForm>
    </Create>
  );
}
